import { render } from "./RegistrationProcess.vue?vue&type=template&id=16ca835b&scoped=true"
import script from "./RegistrationProcess.vue?vue&type=script&lang=js"
export * from "./RegistrationProcess.vue?vue&type=script&lang=js"

import "./RegistrationProcess.vue?vue&type=style&index=0&id=16ca835b&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ca835b"]])

export default __exports__